<div class="delete-dialog">
  <div class="warning-banner">
    <mat-icon class="warning-icon">warning</mat-icon>
    <div class="warning-text">
      <h2>{{ "COMPONENTS.MEDIA_LIBRARY.CONFIRM_DELETE.TITLE" | translate }}</h2>
      <span *ngIf="itemCount > 0">{{ itemCount }} {{ itemCount === 1 ? 'item' : 'items' }} selected</span>
    </div>
  </div>

  <div class="dialog-body">
    <p>{{ "COMPONENTS.MEDIA_LIBRARY.CONFIRM_DELETE.CONTENT" | translate }}</p>
  </div>

  <div class="dialog-actions">
    <button mat-stroked-button (click)="cancel()">
      {{ "COMPONENTS.MEDIA_LIBRARY.CONFIRM_DELETE.CANCEL" | translate }}
    </button>
    <button mat-flat-button color="warn" (click)="delete()">
      <mat-icon>delete_outline</mat-icon>
      {{ "COMPONENTS.MEDIA_LIBRARY.CONFIRM_DELETE.DELETE" | translate }}
    </button>
  </div>
</div>
